var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2910",
    "data-name": "Group 2910",
    transform: "translate(-267 -371)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1317",
    "data-name": "Rectangle 1317",
    width: 24,
    height: 24,
    transform: "translate(267 371)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2909",
    "data-name": "Group 2909",
    transform: "translate(-26.82 -22.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(300.501 397.514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2107",
    "data-name": "Path 2107",
    d: "M10,2.437v1.31h4.051V2.437A.444.444,0,0,0,13.6,2H10.45A.444.444,0,0,0,10,2.437Z",
    transform: "translate(-6.837 -2)",
    fill: "none",
    stroke: "#15355c",
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2108",
    "data-name": "Path 2108",
    d: "M5.175,6.35l1.106,10.5A1.221,1.221,0,0,0,7.5,17.948h5.737a1.221,1.221,0,0,0,1.214-1.093l1.105-10.5Z",
    transform: "translate(-5.175 -2.645)",
    fill: "none",
    stroke: "#15355c",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1316",
    "data-name": "Rectangle 1316",
    transform: "translate(299.067 399.058)",
    fill: "none",
    stroke: "#15355c",
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.506,
    height: 2.161,
    rx: 1.081,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.35,
    y: 0.35,
    width: 12.806,
    height: 1.461,
    rx: 0.731,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2908",
    "data-name": "Group 2908",
    transform: "translate(303.085 402.387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2109",
    "data-name": "Path 2109",
    d: "M2796.765,435.051l1.085,8.74",
    transform: "translate(-2796.765 -435.051)",
    fill: "none",
    stroke: "#15355c",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2110",
    "data-name": "Path 2110",
    d: "M2797.85,435.051l-1.085,8.74",
    transform: "translate(-2792.61 -435.051)",
    fill: "none",
    stroke: "#15355c",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2111",
    "data-name": "Path 2111",
    d: "M1.085,0,0,8.74",
    transform: "translate(1.549 0.132) rotate(-7)",
    fill: "none",
    stroke: "#15355c",
    strokeLinecap: "round",
    strokeWidth: 1
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.9e0a3d7f0dc60353d6ff458565bf08ac.svg";
export { ForwardRef as ReactComponent };